<template>
  <div :class="['user-container', { 'sport-organization-user-container': isSportOrganization() }]">
    <p :class="['description', { 'sport-organization-description': isSportOrganization() }]">
      Prijavljen(a) si kao
    </p>
    <div class="user-description">
      <p :class="['user', { 'sport-organization-user': isSportOrganization() }]">
        <v-icon :style="isSportOrganization() && 'color: white'">person</v-icon
        >{{ user.firstName }} {{ user.lastName }}
      </p>
      <div class="not-you">
        <p :class="['description', { 'sport-organization-description': isSportOrganization() }]">
          Ti nisi {{ user.firstName }}?
        </p>
        <button
          type="button"
          class="button"
          :style="isSportOrganization() && 'color: white; border-bottom-color: white'"
          @click="$emit('login')"
        >
          Klikni ovdje
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { OrganizationType } from '@/types'

export default {
  name: 'logged-in',
  components: {},
  props: {
    user: {
      type: Object,
      default: () => {},
    },
    organizationType: String,
  },
  methods: {
    isSportOrganization() {
      return this.organizationType === OrganizationType.SPORT_ORGANIZATION
    },
  },
}
</script>

<style scoped>
.user-container {
  display: flex;
  width: 100%;
  padding: 32px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
  border-top: 2px solid var(--grey-00, #333);
  background: var(--grey-40, #f5f5f5);
}
.description {
  color: #333;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Rubik;
  font-size: 20px;
  margin-bottom: 0;
  font-style: normal;
  font-weight: 550;
  letter-spacing: -0.6px;
}
.sport-organization-description {
  color: #fff;
  font-family: Raleway;
  font-weight: 600;
  line-height: 120%;
}
.button {
  border-bottom: 0.5px solid #333;
  color: #333;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Rubik;
  font-size: 1rem;
  font-style: normal;
  font-weight: 550;
  line-height: 120%; /* 19.2px */
  letter-spacing: 0.24px;
}
.user-description {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.user {
  color: #333;
  margin-bottom: 0;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Rubik;
  font-size: 18px;
  border-radius: 24px;
  border: 2px solid #333;
  font-style: normal;
  font-weight: 550;
  line-height: 120%; /* 21.6px */
  letter-spacing: 0.27px;
  display: flex;
  height: 46px;
  padding: 12px 24px 12px 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
}
.sport-organization-user {
  color: #fff;
  font-family: Raleway;
  font-weight: 700;
  border: 2px solid white;
}
.not-you {
  display: flex;
  gap: 0.5rem;
}
@media screen and (max-width: 564px) {
  .user-description {
    flex-direction: column;
    align-items: flex-start;
  }
}

.sport-organization-user-container {
  border-radius: 4px;
  border: 1px solid rgba(151, 151, 151, 0.5);
  background: #0054a5;
}
</style>
